import { Typography, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getRandomStr, getTabData } from '../../../../helpers';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
import CommitRoundedIcon from '@mui/icons-material/CommitRounded';
import { getChartSeriesColor } from '../../../../utils';
import DotLine from '../../../../static/images/component/dotline.svg';

const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })

const { ECO_SECTION_CODES } = dataConstants || {};

function YieldCurveChart({ data, getChartData, themes, yData, getYieldTbl, yieldC }) {

  // const yieldC = data && data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_CHART) : undefined;
  const yieldChart = yieldC && yieldC.tabData ? getChartData(yieldC.tabData, getTabData(yData, yieldC, ECO_SECTION_CODES.YIELD_DATA), 'sequenceData') : undefined;

  const yieldTbl = getYieldTbl(yieldChart);

  return (
    <>
      <Box component="div" className="option-content" sx={{}}>
        <Box component="div" sx={{ bgcolor: '#000', }}>
          <Typography variant="caption" className="option-title-desc" sx={{ mr: 'auto' }} dangerouslySetInnerHTML={{ __html: yieldC?.settings?.description }} />
          <Box component="div" className="yield-main-chart eco-chart" sx={{ width: { xs: '100%', sm: '100%', md: '60%' }, m: 'auto', py: 2, minHeight: { md: '25rem', xs: '13.3rem' } }}>
            {yieldChart !== undefined &&
              <D3Chart
                showChart={true}
                //noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...yieldChart, id: yieldC.section_code }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                //chartMargin={{left: 40, bottom: 48 }}
                //axisTextMargin={{ y: 96 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />}
          </Box>
          <Box component="div" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            {yieldChart?.series.map((d, i) => {
              return (
                d?.legend?.label && d?.legend?.label !== '' &&
                <Box key={getRandomStr(4)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, mr: 1.5, '& .dotline': { mr: .7, mb: .5, width: '1em !important', fontSize: '1.1rem !important', fill: getChartSeriesColor(d, yieldChart?.currTheme.pallete[i]) } }}>
                  {d?.setting?.line?.dashArray ? <DotLine className="dotline" /> : <CommitRoundedIcon sx={{ mr: .7, width: '1em !important', fontSize: '1.1rem !important', color: getChartSeriesColor(d, yieldChart?.currTheme.pallete[i]) }} />}
                  <Typography variant="p" sx={{ fontSize: '.67rem', fontWeight: 600, color: '#fff' }}>{d.legend.label}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
        {yieldTbl !== undefined &&
          <Box component="div" className="yield-tbl">
            {yieldTbl}
          </Box>}
      </Box>
    </>
  )
}

export default YieldCurveChart
